import { render, staticRenderFns } from "./verify_OTP.vue?vue&type=template&id=5e9bb41b"
import script from "./verify_OTP.vue?vue&type=script&lang=js"
export * from "./verify_OTP.vue?vue&type=script&lang=js"
import style0 from "./verify_OTP.vue?vue&type=style&index=0&id=5e9bb41b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports